<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click v-on:click.native="clearUnread" ref="notificationDropdown" class="cursor-pointer">
    <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="numUnreadNotifications" badgeColor="danger" />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">
      <div class="notification-top text-center p-5 bg-primary text-white opacity-75">
        <h3 class="text-white">{{ numUnreadNotifications }} New</h3>
        <p class="opacity-75">Notifications</p>
      </div>

      <component
        :is="scrollbarTag"
        ref="mainSidebarPs"
        class="scroll-area--nofications-dropdown p-0"
        style
        :settings="settings"
        :key="$vs.rtl"
      >
        <!--  mb-10 hvis "View all notifications" -->
        <ul
          class="bordered-items"
          :class="{
            'mb-10': notifications.length === 0
          }"
        >
          <li
            v-for="(ntf, idx) in notifications"
            :key="idx"
            @click="ntfClicked(ntf)"
            class="flex justify-between px-4 py-4 notification"
            :class="{
              'cursor-pointer': getDetailsByType(ntf.aggregateType).clickable
            }"
          >
            <div class="flex items-start">
              <feather-icon
                :icon="getDetailsByType(ntf.aggregateType).icon"
                :svgClasses="[`text-${getDetailsByType(ntf.aggregateType).color}`, 'stroke-current mr-1 h-6 w-6']"
              ></feather-icon>
              <div class="mx-2">
                <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.title }}</span>
                <small>{{ ntf.description }}</small>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap flex justify-center align-center">{{ format(ntf.timestamp) }} </small>
            <vs-chip v-if="!ntf.isRead" color="danger" class="status-circle"></vs-chip>
          </li>
        </ul>
      </component>

      <div
        v-if="notifications.length === 0"
        class="checkout-footer fixed bottom-0 rounded-b-lg text-primary w-full p-2 text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light"
      >
        <span>No notifications to show</span>
      </div>

      <!--<div
        class="
          checkout-footer
          fixed
          bottom-0
          rounded-b-lg
          text-primary
          w-full
          p-2
          font-semibold
          text-center
          border border-b-0 border-l-0 border-r-0 border-solid
          d-theme-border-grey-light
          cursor-pointer
        "
      >
        <span>View All Notifications</span>
      </div>-->
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapGetters } from "vuex";
import { format } from "timeago.js";
import router from "@/router";
export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      dropdownOpen: this.$refs.notificationDropdown ? this.$refs.notificationDropdown.vsDropdownVisible : false,
      format,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    ...mapGetters({
      numUnreadNotifications: "users/numUnreadNotifications",
      notifications: "users/notifications"
    }),

    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  methods: {
    getDetailsByType(type) {
      switch (type) {
        case "completedEducation":
          return {
            icon: "UserCheckIcon",
            clickable: false,
            color: "primary"
          };
        case "listSubmission":
          return {
            icon: "ListIcon",
            clickable: true,
            color: "success"
          };
        case "eodReport":
          return {
            icon: "ListIcon",
            clickable: true,
            color: "success"
          };
        case "venueCampaign":
          return {
            icon: "LayersIcon",
            clickable: true,
            color: "success"
          };
        case "pimStockProductRequest":
          return {
            icon: "ShoppingCartIcon",
            clickable: false,
            color: "success"
          };
        case "wsStockProductRequestAnswer":
          return {
            icon: "ShoppingCartIcon",
            clickable: false,
            color: "success"
          };
        case "wsStockTransferRequest":
          return {
            icon: "ShoppingCartIcon",
            clickable: true,
            color: "success"
          };
        case "wsStockTransferRequestAnswer":
          return {
            icon: "ShoppingCartIcon",
            clickable: true,
            color: "success"
          };
        case "wsStockProductMinimumAmount":
          return {
            icon: "ShoppingCartIcon",
            clickable: true,
            color: "success"
          };
        case "newVenueCreated":
          return {
            icon: "HomeIcon",
            clickable: true,
            color: "success"
          };
        case "wsStocktakeDeviation":
          return {
            icon: "ShoppingCartIcon",
            clickable: true,
            color: "success"
          };
        case "meetingEnded":
          return {
            icon: "ClipboardIcon",
            clickable: true,
            color: "success"
          };
        default:
          console.warn("WARNING: Notification type not found: " + type);
          break;

        /*todosuccess: "MessageSquareIcon",
        todowarning: "PackageIcon",
        todoerror: "AlertOctagonIcon",*/
      }
    },
    ntfClicked(ntf) {
      console.log("Clicked ntf", ntf);
      switch (ntf.aggregateType) {
        case "listSubmission":
          var type = ntf.resourceId.split(":")[0];
          var listSubmissionId = ntf.resourceId.split(":")[1];
          this.switchVenue(ntf.venueId, {
            name: "list-submission",
            params: { type: type, id: listSubmissionId }
          });
          this.$vs.notify({
            title: ntf.venueName,
            text: "Venue switched to " + ntf.venueName
          });
          break;
        case "eodReport":
          this.switchVenue(ntf.venueId, {
            name: "eodReport",
            params: { id: ntf.resourceId }
          });
          this.$vs.notify({
            title: ntf.venueName,
            text: "Venue switched to " + ntf.venueName
          });
          break;
        case "venueCampaign":
          this.switchVenue(ntf.venueId, {
            name: "vp-venuecampaign",
            params: { id: ntf.resourceId }
          });
          this.$vs.notify({
            title: ntf.venueName,
            text: "Venue switched to " + ntf.venueName
          });
          break;
        case "wsStockTransferRequest":
          this.switchVenue(ntf.venueId, {
            name: "vp-pim-stock-transfers"
            //params: { id: ntf.resourceId },
          });
          this.$vs.notify({
            title: ntf.venueName,
            text: "Venue switched to " + ntf.venueName
          });
          break;
        case "wsStockTransferRequestAnswer":
          this.switchVenue(ntf.venueId, {
            name: "vp-pim-stock-transfers"
            //params: { id: ntf.resourceId },
          });
          this.$vs.notify({
            title: ntf.venueName,
            text: "Venue switched to " + ntf.venueName
          });
          break;
        case "wsStockProductMinimumAmount":
          this.switchVenue(ntf.venueId, {
            name: "vp-pim-desired-stock"
            //params: { id: ntf.resourceId },
          });
          this.$vs.notify({
            title: ntf.venueName,
            text: "Venue switched to " + ntf.venueName
          });
          break;
        case "newVenueCreated":
          this.switchVenue(ntf.venueId, {
            name: "venue-info"
            //params: { id: ntf.resourceId },
          });
          this.$vs.notify({
            title: ntf.venueName,
            text: "Venue switched to " + ntf.venueName
          });
          break;
        case "wsStocktakeDeviation":
          this.switchVenue(ntf.venueId, {
            name: "vp-pim-stocktake",
            params: { id: ntf.resourceId }
          });
          this.$vs.notify({
            title: ntf.venueName,
            text: "Venue switched to " + ntf.venueName
          });
          break;
        case "meetingEnded":
          this.switchVenue(ntf.venueId, {
            name: "vp-meeting",
            params: { id: ntf.resourceId.split(":")[1] }
          });
          this.$vs.notify({
            title: ntf.venueName,
            text: "Venue switched to " + ntf.venueName
          });
          break;
      }
    },
    clearUnread() {
      this.$store.dispatch("users/markNotificationsRead");
    }
  }
};
</script>

<style scoped>
.status-circle {
  width: 10px;
  height: 10px;
  min-width: 10px;
  min-height: 10px;
  margin-left: 8px;
}
</style>

